export const CHECK_TOKEN = "CHECK_TOKEN";

export const GET_PROFILE = "GET_PROFILE";

export const GET_FISCAL_YEAR = "GET_FISCAL_YEAR";

export const SET_FISCAL_YEAR = "SET_FISCAL_YEAR";

export const SET_PRODUCT = "SET_PRODUCT";
